<template>
  <footer class="contact-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img src="@/assets/logo.png" alt="銘成工程有限公司標誌" />
        <div>
          <strong>銘成工程有限公司</strong>
          <small>MSUCCE ENGINEERING CO., LIMITED</small>
          <p>劉泳銘　｜　東主</p>
          <!-- <p>政府註冊電業承辦商</p> -->
        </div>
      </div>
      <div class="footer-column">
        <h2>聯絡我們</h2>
        <p>香港新界上水龍琛路39號上水廣場1610室</p>
        <p>電話：67645924</p>
        <p>傳真：38555784</p>
        <p><a href="mailto:ming@msucce.com">電郵：ming@msucce.com</a></p>
      </div>
      <div class="footer-column footer-links">
        <h2>快速導覽</h2>
        <router-link to="/aboutus">關於我們</router-link>
        <router-link to="/engineering">工程能力</router-link>
        <router-link to="/projects">項目案例</router-link>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© {{ new Date().getFullYear() }} 銘成工程有限公司</span>
      <span>專業 · 創新 · 高效</span>
    </div>
  </footer>
</template>

<script>
export default { name: 'ContactUs' };
</script>

<style scoped>
.contact-footer { padding: 70px 0 24px; background: #17242c; color: #fff; }
.footer-inner { width: min(1280px, calc(100% - 64px)); margin: 0 auto; display: grid; grid-template-columns: 1.3fr 1fr .55fr; gap: 70px; text-align: left; }
.footer-brand { display: flex; align-items: flex-start; gap: 15px; }
.footer-brand img { width: 44px; height: 44px; object-fit: contain; }
.footer-brand strong { font-size: 18px; }
.footer-brand small { display: block; margin-top: 5px; color: #d5dadd; font-size: 10px; letter-spacing: .06em; }
.footer-brand p { margin: 12px 0 0; color: #aeb7ba; font-size: 13px; }
.footer-column h2 { margin: 0 0 22px; color: #f4c451; font-size: 14px; }
.footer-column p { margin: 0 0 12px; color: #c1c8ca; font-size: 13px; line-height: 1.7; }
.footer-column p a { color: inherit; text-decoration: none; }
.footer-column p a:hover { color: #f4c451; }
.footer-links { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; }
.footer-links a { color: #c1c8ca; font-size: 13px; text-decoration: none; }
.footer-links a:hover { color: #f4c451; }
.footer-bottom { width: min(1280px, calc(100% - 64px)); margin: 60px auto 0; padding-top: 20px; border-top: 1px solid rgba(255,255,255,.15); display: flex; justify-content: space-between; color: #879397; font-size: 12px; }
@media (max-width: 800px) { .footer-inner { width: min(100% - 36px, 600px); grid-template-columns: 1fr; gap: 36px; } .footer-bottom { width: min(100% - 36px, 600px); margin-top: 40px; gap: 16px; flex-direction: column; } }
</style>
